import View from './View'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'


class AccordionView extends View {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
    
    const items = [...container.querySelectorAll(".accordionpanel-card")]
    items.forEach((el, index) => {
      const del = index * .2;
      const title = el.querySelector(".accordionpanel-title span")
      const t = new TimelineMax({repeat: 0})
      t.set(el, {opacity: 1, y: 0})
      t.set(title, {opacity: 1, y: 0})
      t.from(el, .3, {opacity: 0, delay: del}, .1)
      t.from(title, .3, {y: 30, opacity: 0, ease: Power4.easeOut}, .3)
    })
    
    
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    
    const items = [...container.querySelectorAll(".accordionpanel-card")]
    items.forEach((el, index) => {
      const del = index * .07;
      const title = el.querySelector(".accordionpanel-title span")
      const t = new TimelineMax({repeat: 0})
      t.to(title, .3, {y: 20, opacity: 0, ease: Power4.easeIn}, 0)
      t.to(el, .3, {opacity: 0, delay: del}, .2)
    })
    
    
  }

}

export default AccordionView